module.exports = __webpack_public_path__ + "static/media/financialnigeria.3f2e5293.png";